import { render } from "./Encerramento.vue?vue&type=template&id=4615db92"
import script from "./Encerramento.vue?vue&type=script&lang=js"
export * from "./Encerramento.vue?vue&type=script&lang=js"

import "./Encerramento.vue?vue&type=style&index=0&id=4615db92&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__